import CustomerDetails from '../../../shared/CustomerDetailsPage/CustomerDetails';
import CustomerJourneyStep from './CustomerJourneyStep';

const CustomerDetailsPage = () => <CustomerDetails JourneySteps={CustomerJourneyStep} forCI />;

export default CustomerDetailsPage;
